
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCellMedium as ObiCellMediumElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cell-medium.js';
 
 
 

 
 export const ObiCellMedium = createComponent({
   react: React,
   tagName: 'obi-cell-medium',
   elementClass: ObiCellMediumElement,
   events: {
     
   }
  });
 
 